const cachedConfigData = {}

export const configs = {
  DATA_AGGREGATION: 'dataAggregation.config.json',
  DEFAULT_POI: 'defaultPOI.config.json',
  DEFAULT_STATE: 'defaultState.config.json',
  MISC: 'misc.config.json',
  POI: 'poi.config.json',
  PERSONAS: 'personas.config.json',
  FILTERS: 'filter.config.json',
  USECASE: 'useCases.config.json'
}

export const getConfigData = async (configName) => {
  if (cachedConfigData[configName] == null) {
    const response = await fetch(`/config/${configName}`)
    const data = await response.json()
    cachedConfigData[configName] = data
    return data
  } else {
    return cachedConfigData[configName]
  }
}
